'use client';

import { storyblokEditable } from '@storyblok/react/rsc';
import { FC } from 'react';
import { DailyDealsStoryblok } from 'storyblok-types';
import { isValidDate } from 'modules/stroyblok/services';
import { DailyDeal } from './DailyDeal';
import styles from './styles.module.css';

export const DailyDeals: FC<{ blok: DailyDealsStoryblok }> = ({ blok }) => {
  const minCountOfElements = 2;
  const validItems = blok.list
    .filter((item) => isValidDate(item.start_date, item.expiration_date))
    .slice(0, minCountOfElements); // take first two valid elements

  return validItems.length < minCountOfElements ? null : (
    <div className={styles.list} {...storyblokEditable(blok)}>
      {validItems.map((item) => (
        <DailyDeal key={item._uid} data={item} />
      ))}
    </div>
  );
};
